import kamala from '../../kamala'
import Input from './Input'
import TextArea from './TextArea'
// import _ from 'lodash'
//
// const TextArea = _.cloneDeep(Input)
// const data = _.assign(TextArea.data(), {
//   isTextArea: true,
// })
// TextArea.name = 'KTextArea'
// TextArea.data = function() {
//   return data
// }

const KInputFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Input.name, Input)
    Vue.component(TextArea.name, TextArea)
  },
  KInput: Input,
  KTextArea: TextArea,
}

export { Input, TextArea }

export default KInputFamily
